import React from "react";
import { motion } from "framer-motion";

export default function KanbanMini({ items }) {
  return (
    <div className="erp-mini-kanban">
      {items.map((item, index) => (
        <motion.div
          className="erp-mini-kanban-col"
          key={item.title}
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05, duration: 0.25 }}
          whileHover={{ y: -4 }}
          whileTap={{ scale: 0.985 }}
        >
          <div className="erp-mini-kanban-title">{item.title}</div>
          <div className="erp-mini-kanban-value">{item.value}</div>
          <div className="erp-mini-kanban-meta">{item.meta}</div>
        </motion.div>
      ))}
    </div>
  );
}
